import { createSlice  } from '@reduxjs/toolkit';
// import purseService from './purseAction';

const initialState = {
    balance : {}
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        saveBalance: (state, action) => {
            state.balance = action.payload
        },
    }
})

export const AllBalance = (state) => state;

export const {saveBalance} = userSlice.actions

export default userSlice.reducer;